import { Users, Clock } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import type { PayrollRunSummary } from '@/services/payroll/types';

interface SelectedEmployeeSummaryProps {
  summary: PayrollRunSummary;
}

export const SelectedEmployeeSummary = ({ summary }: SelectedEmployeeSummaryProps) => {
  const formatHours = (hours: number) => {
    return hours.toFixed(2);
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <Card>
        <CardContent className="pt-6">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-primary/10 rounded-lg">
              <Users className="h-5 w-5 text-primary" />
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Employees Selected</p>
              <p className="text-2xl font-bold">{summary.selectedCount}</p>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="pt-6">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-primary/10 rounded-lg">
              <Clock className="h-5 w-5 text-primary" />
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Total Hours</p>
              <p className="text-2xl font-bold">{formatHours(summary.totalHours)}</p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
